import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  textfield: css`
    & .MuiInputLabel-root {
      font-family: 'Montserrat Regular';
      color: ${colors.slate};
      line-height: 1.33;
      letter-spacing: -0.3px;
      margin: 0 0 4px;
      text-align: left;
    }
    & .MuiInput-input {
      font-family: 'Montserrat Regular';
      color: ${colors.prussian};
      font-size: 16px;
      line-height: 1.5;
      letter-spacing: -0.5px;
      text-align: left;
      padding-bottom: 8px !important;
    }
    .MuiFormHelperText-root {
      font-family: 'Montserrat Regular';
      font-size: 12px;
      color: ${colors.dragon} !important;
      line-height: 1.33;
      letter-spacing: -0.3px;
    }
  `,
};
export default styles;
